import * as Yup from 'yup'

const changeCustomerServicesValidator = Yup.object ({
  exchange_option: Yup.object ()
    .nullable ()
    .required ('Selecione uma opção de troca'),

  new_services: Yup.array ().of (Yup.object ().shape ({
    id: Yup.string (),
    name: Yup.string ().when ('$exchange_option', {
      is: type => type?.value === 'services_exchange',
      then: schema => schema.required ('Selecione um serviço'),
      otherwise: schema => schema.notRequired ()
    }),
    amount: Yup.number ()
  }))
})

export default changeCustomerServicesValidator
